export const excessStockInPercentage = {
    'percentage' :'5'
}
export default excessStockInPercentage;